import { render, staticRenderFns } from "./FilterDeliverySacPublic.vue?vue&type=template&id=48c707e8"
import script from "./FilterDeliverySacPublic.vue?vue&type=script&lang=ts"
export * from "./FilterDeliverySacPublic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports